module.exports = __webpack_public_path__ + "img/user_gray.ad569340.svg";